import { isPortalSelfEmbedUrl } from '@/utils/iframeUrl';

export function launchProductUrlInNewTab(url: string): void {
  if (!url || isPortalSelfEmbedUrl(url)) {
    return;
  }

  window.open(url, '_blank', 'noopener,noreferrer');
}
